import {messages} from '@/assets/messages';

// In the future, we may want to support multiple clients, e.g., fetching messages from a server
interface LickedLemonsApiClient
{
  getMessage(): Promise<string>
}

// Loads messages from the static messages file
class StaticClient implements LickedLemonsApiClient
{
  getMessage()
  {
    return Promise.resolve(messages[Math.floor(Math.random() * messages.length)]);
  }
}

// Mockup of an API client that retrieves messages from a server
// class ServerClient implements LickedLemonsApiClient {
//   getMessage (): Promise<string>
//   {
//     // Try to load a message from the server
//     try
//     {
//       let response = await axios.get('https://api.lickedlemons.com/message');
//       return response.data.message;
//     }
//     catch (err)
//     {
//       // Fall back to the statically bundled messages
//       return new StaticClient().getMessage();
//     }
//   }
// }

// Mockup of an API client with delays for UI testing
// class SlowClient implements LickedLemonsApiClient
// {
//   getMessage()
//   {
//     let message = messages[Math.floor(Math.random() * messages.length)];
//
//     return new Promise<string>((resolve, reject) => {
//       setTimeout(() => resolve(message), 5000);
//     });
//   }
// }

// The actual value of the export could be determined at runtime, for instance,
// after examining NODE_ENV
export const APIClient = new StaticClient();
